import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DealerType } from "../types/DealerType";
import { apiClient } from "src/utils/Api/apiClient";

interface allDealerState {
        dealers: Array<DealerType>;
        dealersLoading: boolean;
        dealersError: string | null;
}

const initialState: allDealerState = {
        dealers: [],
        dealersLoading: true,
        dealersError: null
}

export const deleteDealer = createAsyncThunk(
        'dealer/deleteDealer',
        async (dealerData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('dealer/deleteDealer', dealerData).then();
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

export const getDealers = createAsyncThunk(
        'dealers/getDealers',
        async (dealerData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get('dealer/getDealers', dealerData);
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

const dealersSlice = createSlice({
        name: 'dealers',
        initialState,
        reducers: {
                dealersReset: () => initialState,
        },
        extraReducers: (builder) => {
                //get all Dealers from server
                builder.addCase(getDealers.pending, (state) => {
                        state.dealersLoading = true;
                        state.dealersError = null;
                });
                builder.addCase(getDealers.fulfilled, (state, action) => {
                        state.dealersLoading = false;
                        state.dealers = action.payload;
                });
                builder.addCase(getDealers.rejected, (state, action) => {
                        state.dealersLoading = false;
                        state.dealersError = action.payload as string;
                });

                //delete dealer from server
                builder.addCase(deleteDealer.pending, (state) => {
                        state.dealersLoading = true;
                        state.dealersError = null;
                });
                builder.addCase(deleteDealer.fulfilled, (state, action) => {
                        state.dealersLoading = false;
                        const id = action.payload.Id;
                        state.dealers = state.dealers.filter(item => item.Id !== parseInt(id));
                });
                builder.addCase(deleteDealer.rejected, (state, action) => {
                        state.dealersLoading = false;
                        state.dealersError = action.payload as string;
                });

        }
});

export const { dealersReset } = dealersSlice.actions;
export default dealersSlice.reducer;
